import {ChildEntity, Column} from "typeorm";
import {Incident} from "@/modules/match/entity/Incident";
import MissedGoalIncidentComponent from '@/modules/match/components/MissedGoalIncident.vue';
import MissedGoalIncidentLiveComponent from '@/modules/match/components/live-incident/MissedGoalIncident.vue';

import {Component, ShallowRef} from "vue";

@ChildEntity()
export class MissedGoalIncident extends Incident {
  @Column({type: 'boolean'})
  penalty = false;

  get component(): ShallowRef<Component> {
    return shallowRef(MissedGoalIncidentComponent);
  }

  get liveComponent(): ShallowRef<Component> {
    return shallowRef(MissedGoalIncidentLiveComponent);
  }
}
